<div class="h100">
  <div class="page-title">년도별 수출입 통계</div>

  <div class="mb10">
    <div class="unit">(대,US$)</div>
  </div>

  <div class="statistics">
	  <div class="statistics-left">
      <ag-grid-angular
        #myGrid

        style="width: 100%;height:calc(100% - 0px);"
        class="ag-theme-balham"

        [columnDefs]="columnDefsProd"
        [defaultColDef]="defaultColDefProd"
        [rowData]="prodList"
        [pagination]="false"
        [overlayNoRowsTemplate]="noRowsTemplate"
        [rowSelection]="rowSelectionProd"
        [frameworkComponents]="frameworkComponents"

        (gridReady)="onGridReadyProd($event)"
        (rowClicked)="onRowClicked($event)"
      >
      </ag-grid-angular>
	  </div>

	  <div class="statistics-table">
      <ag-grid-angular
        #myGrid

        style="width: 100%;height:calc(100% - 0px);"
        class="ag-theme-balham"

        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowData]="dataList"
        [pagination]="false"
        [overlayNoRowsTemplate]="noRowsTemplate"
        [rowSelection]="rowSelection"
        [frameworkComponents]="frameworkComponents"

        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
	  </div>
  </div>
</div>
